<template>
  <div>
    <div 
      v-if="$acl.check('isAcademicPlanning')"
      class="floating-button-container"
      ref="draggableBtn"
      :style="{ top: floatBtn.y + 'px', left: floatBtn.x + 'px' }"
      @mousedown.prevent="dragStart"
      @touchstart.prevent="dragStart"
    >
      <vs-button 
        color="danger" 
        type="filled" 
        icon="info" 
        radius
        size="large"
        style="border: 2px solid #ffffff; box-shadow: 0px 4px 10px rgba(0,0,0,0.3);"
        @click="openConsultPopup"
      ></vs-button>
    </div>

    <vs-popup class="popup-consultas custom-large-popup" title="Consultas de Validação MAT" :active.sync="showConsultPopup">
      <div class="popup-inner-margin">
        <div style="margin-bottom: 20px;">
          <vs-row>
            <vs-col vs-w="6">
              <vs-button color="primary" @click="runValMat01" style="width: 100%;">Executar REL.VAL.MAT01</vs-button>
            </vs-col>
            <vs-col vs-w="6">
              <vs-button color="success" @click="runValMat02" style="width: 100%;">Executar REL.VAL.MAT02</vs-button>
            </vs-col>
          </vs-row>
          
          <vs-row style="margin-top: 15px; align-items: center;">
            <vs-col vs-w="6">
              <vs-button color="dark" icon="save_alt" size="small" @click="exportToExcelHTML">Exportar para Excel</vs-button>
            </vs-col>
            
            <vs-col vs-w="6" style="display: flex; justify-content: flex-end;">
              <div class="legend-container">
                <strong>Ordem:</strong>
                <span class="legend-badge" style="background-color: #FF7F50; color: #fff;">1</span>
                <span class="legend-badge" style="background-color: #1E90FF; color: #fff;">2</span>
                <span class="legend-badge" style="background-color: #00FF7F; color: #000;">3</span>
                <span class="legend-badge" style="background-color: #836FFF; color: #fff;">4</span>
                <span class="legend-badge" style="background-color: #DA70D6; color: #fff;">5</span>
              </div>
            </vs-col>
          </vs-row>
        </div>

        <div class="tables-container">
          <div class="table-wrapper">
            <div class="table-header">
              <h4>Disciplinas (MAT01)</h4>
              <input type="text" v-model="filterTable01" placeholder="Buscar em MAT01..." class="table-search-input" />
            </div>
            <div class="table-responsive">
              <table class="custom-table" id="table-mat01">
                <thead>
                  <tr>
                    <th>IDCLASSIFICACAO</th>
                    <th>CODDISC</th>
                    <th>DISCIPLINA</th>
                    <th>ORDEM</th>
                    <th>PRIORIDADE</th>
                    <th>TIPO</th>
                    <th>CODCURSO</th>
                    <th>CODGRADE</th>
                    <th>PRAZOCURSO</th>
                    <th>MODALIDADE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="(row, idx) in filteredTable01Data" 
                    :key="idx" 
                    @click="toggleDisciplina(row.CODDISC)"
                    :style="{ backgroundColor: isDisciplinaActive(row.CODDISC) ? getOrderColor(row.ORDEM) : 'transparent' }"
                    class="clickable-row"
                  >
                    <td>{{ row.IDCLASSIFICACAO }}</td>
                    <td>{{ row.CODDISC }}</td>
                    <td>{{ row.DISCIPLINA || row.DISCIPLI }}</td>
                    <td>{{ row.ORDEM }}</td>
                    <td>{{ row.PRIORIDADE }}</td>
                    <td>{{ row.TIPO }}</td>
                    <td>{{ row.CODCURSO }}</td>
                    <td>{{ row.CODGRADE }}</td>
                    <td>{{ row.PRAZOCURSO }}</td>
                    <td>{{ row.MODALIDADE }}</td>
                  </tr>
                  <tr v-if="filteredTable01Data.length === 0">
                    <td colspan="10" style="text-align: center;">Nenhum dado encontrado</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="table-wrapper">
            <div class="table-header">
              <h4>Turmas (MAT02)</h4>
              <input type="text" v-model="filterTable02" placeholder="Buscar em MAT02..." class="table-search-input" />
            </div>
            <div class="table-responsive">
              <table class="custom-table" id="table-mat02">
                <thead>
                  <tr>
                    <th>NOMETURMA</th>
                    <th>CODCURSO</th>
                    <th>CODTURMA</th>
                    <th>IDTURMADISC</th>
                    <th>CODDISC</th>
                    <th>DISCIPLINA</th>
                    <th>DTINICIAL</th>
                    <th>DTFINAL</th>
                    <th>ORDEM</th>
                    <th>PRIORIDADE</th>
                    <th>TIPO</th>
                    <th>VAGAS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="(row, idx) in filteredTable02Data" 
                    :key="idx" 
                    @click="toggleTurma(row)"
                    :style="{ backgroundColor: isTurmaActive(row) ? getOrderColor(row.ORDEM) : 'transparent' }"
                    class="clickable-row"
                  >
                    <td>{{ row.NOMETURMA }}</td>
                    <td>{{ row.CODCURSO }}</td>
                    <td>{{ row.CODTURMA }}</td>
                    <td>{{ row.IDTURMADISC }}</td>
                    <td>{{ row.CODDISC }}</td>
                    <td>{{ row.DISCIPLINA || row.DISCIPLI }}</td>
                    <td>{{ row.DTINICIAL }}</td>
                    <td>{{ row.DTFINAL }}</td>
                    <td>{{ row.ORDEM }}</td>
                    <td>{{ row.PRIORIDADE }}</td>
                    <td>{{ row.TIPO }}</td>
                    <td>{{ row.VAGAS }}</td>
                  </tr>
                  <tr v-if="filteredTable02Data.length === 0">
                    <td colspan="12" style="text-align: center;">Nenhum dado encontrado</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Course from "../services/courses";
import { getStepsInformation } from "../helpers";

export default {
  name: "ConsultValidationMat",
  data: () => ({
    course: null,
    showConsultPopup: false,
    table01Data: [],
    table02Data: [],
    filterTable01: "",
    filterTable02: "",
    activeDisciplinas: {}, 
    activeTurmas: {}, 
    floatBtn: { x: 0, y: 0 },
    dragging: false,
    dragOffset: { x: 0, y: 0 }
  }),

  computed: {
    filteredTable01Data() {
      if (!this.filterTable01) return this.table01Data;
      const term = this.filterTable01.toLowerCase();
      return this.table01Data.filter(row => Object.values(row).some(val => String(val || '').toLowerCase().includes(term)));
    },
    filteredTable02Data() {
      if (!this.filterTable02) return this.table02Data;
      const term = this.filterTable02.toLowerCase();
      return this.table02Data.filter(row => Object.values(row).some(val => String(val || '').toLowerCase().includes(term)));
    }
  },

  methods: {
    openConsultPopup() {
      if (!this.dragging) {
        this.showConsultPopup = true;
      }
    },

    getOrderColor(ordem) {
      const colors = { 1: '#FF7F50', 2: '#1E90FF', 3: '#00FF7F', 4: '#836FFF', 5: '#DA70D6' };
      return colors[ordem] || 'transparent';
    },

    toggleDisciplina(coddisc) {
      if (!coddisc) return;
      this.$set(this.activeDisciplinas, coddisc, !this.activeDisciplinas[coddisc]);
    },

    toggleTurma(row) {
      const key = row.IDTURMADISC || `${row.CODCURSO}_${row.CODDISC}_${row.CODTURMA}`;
      this.$set(this.activeTurmas, key, !this.activeTurmas[key]);
    },

    isDisciplinaActive(coddisc) {
      if (!coddisc) return false;
      if (this.activeDisciplinas[coddisc]) return true;
      return this.table02Data.some(turma => {
        const key = turma.IDTURMADISC || `${turma.CODCURSO}_${turma.CODDISC}_${turma.CODTURMA}`;
        return turma.CODDISC == coddisc && this.activeTurmas[key];
      });
    },

    isTurmaActive(row) {
      if (!row) return false;
      if (this.activeDisciplinas[row.CODDISC]) return true;
      const key = row.IDTURMADISC || `${row.CODCURSO}_${row.CODDISC}_${row.CODTURMA}`;
      return !!this.activeTurmas[key];
    },

    getTargetOffer() {
      const { offer } = getStepsInformation();
      return Array.isArray(offer) ? (offer[0] || {}) : (offer || {});
    },

    runValMat01() {
      this.$vs.loading({ color: "danger" });      
      this.activeDisciplinas = {};
      this.activeTurmas = {};

      const targetOffer = this.getTargetOffer();
      const idClassificacao = targetOffer.IDCLASSIFICACAO || this.course.IDCLASSIFICACAO || 0;
      const codCurso = targetOffer.CODCURSO || this.course.CODCURSO || 0;

      new Course().getValMat01(idClassificacao, codCurso)
        .then(({ data }) => { this.table01Data = Array.isArray(data) ? data : [data]; })
        .catch(err => {
          this.$vs.notify({ title: 'Erro', text: 'Falha ao executar MAT01', color: 'danger' });
          console.error(err);
        })
        .finally(() => this.$vs.loading.close());
    },

    runValMat02() {
      this.$vs.loading({ color: "danger" });
      this.activeDisciplinas = {};
      this.activeTurmas = {};

      const targetOffer = this.getTargetOffer();
      const idClassificacao = targetOffer.IDCLASSIFICACAO || this.course.IDCLASSIFICACAO || 0;
      const codCurso = targetOffer.CODCURSO || this.course.CODCURSO || 0;
      const idHabilitacaoFilial = targetOffer.IDHABILITACAOFILIAL || this.course.IDHABILITACAOFILIAL || 0;
      const codPolo = targetOffer.CODCAMPUS || this.course.CODFILIALPOLO || 0;
      const nomeTurma = targetOffer.NOMETURMA ? encodeURIComponent(targetOffer.NOMETURMA) : '%25';

      new Course().getValMat02(idClassificacao, codCurso, idHabilitacaoFilial, codPolo, nomeTurma)
        .then(({ data }) => { this.table02Data = Array.isArray(data) ? data : [data]; })
        .catch(err => {
          this.$vs.notify({ title: 'Erro', text: 'Falha ao executar MAT02', color: 'danger' });
          console.error(err);
        })
        .finally(() => this.$vs.loading.close());
    },

    exportToExcelHTML() {
      const keys1 = [
        { key: 'IDCLASSIFICACAO', label: 'IDCLASSIFICACAO' }, { key: 'CODDISC', label: 'CODDISC' },
        { key: 'DISCIPLINA', label: 'DISCIPLINA' }, { key: 'ORDEM', label: 'ORDEM' },
        { key: 'PRIORIDADE', label: 'PRIORIDADE' }, { key: 'TIPO', label: 'TIPO' },
        { key: 'CODCURSO', label: 'CODCURSO' }, { key: 'CODGRADE', label: 'CODGRADE' },
        { key: 'PRAZOCURSO', label: 'PRAZOCURSO' }, { key: 'MODALIDADE', label: 'MODALIDADE' }
      ];

      const keys2 = [
        { key: 'NOMETURMA', label: 'NOMETURMA' }, { key: 'CODCURSO', label: 'CODCURSO' },
        { key: 'CODTURMA', label: 'CODTURMA' }, { key: 'IDTURMADISC', label: 'IDTURMADISC' },
        { key: 'CODDISC', label: 'CODDISC' }, { key: 'DISCIPLINA', label: 'DISCIPLINA' },
        { key: 'DTINICIAL', label: 'DTINICIAL' }, { key: 'DTFINAL', label: 'DTFINAL' },
        { key: 'ORDEM', label: 'ORDEM' }, { key: 'PRIORIDADE', label: 'PRIORIDADE' },
        { key: 'TIPO', label: 'TIPO' }, { key: 'VAGAS', label: 'VAGAS' }
      ];
      
      let html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head><meta charset="utf-8"><style>th { background-color: #f2f2f2; border: 1px solid #000; font-weight: bold; } td { border: 1px solid #ddd; }</style></head>
        <body><table><thead><tr>`;
      
      keys1.forEach(k => html += `<th>${k.label}</th>`);
      html += `<th></th>`;
      keys2.forEach(k => html += `<th>${k.label}</th>`);
      html += `</tr></thead><tbody>`;

      const sourceData1 = this.filteredTable01Data;
      const sourceData2 = this.filteredTable02Data;
      const maxRows = Math.max(sourceData1.length, sourceData2.length);

      for (let i = 0; i < maxRows; i++) {
        const row1 = sourceData1[i] || {};
        const row2 = sourceData2[i] || {};
        
        const color1 = row1.CODDISC && this.isDisciplinaActive(row1.CODDISC) ? this.getOrderColor(row1.ORDEM) : '#ffffff';
        const color2 = row2.CODDISC && this.isTurmaActive(row2) ? this.getOrderColor(row2.ORDEM) : '#ffffff';

        html += `<tr>`;
        keys1.forEach(col => {
          const val = row1[col.key] !== undefined ? row1[col.key] : (col.key === 'DISCIPLINA' ? (row1.DISCIPLI || '') : '');
          html += `<td style="background-color: ${color1}">${val}</td>`;
        });
        html += `<td></td>`;
        keys2.forEach(col => {
          const val = row2[col.key] !== undefined ? row2[col.key] : (col.key === 'DISCIPLINA' ? (row2.DISCIPLI || '') : '');
          html += `<td style="background-color: ${color2}">${val}</td>`;
        });
        html += `</tr>`;
      }

      html += `</tbody></table></body></html>`;

      const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `validacao_mat_${this.course ? this.course.RA : 'export'}.xls`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    dragStart(event) {
      this.dragging = false; 
      const e = event.type === 'touchstart' ? event.touches[0] : event;
      this.dragOffset.x = e.clientX - this.floatBtn.x;
      this.dragOffset.y = e.clientY - this.floatBtn.y;
      const moveEvent = event.type === 'touchstart' ? 'touchmove' : 'mousemove';
      const upEvent = event.type === 'touchstart' ? 'touchend' : 'mouseup';
      document.addEventListener(moveEvent, this.doDrag);
      document.addEventListener(upEvent, this.stopDrag);
    },
    doDrag(event) {
      this.dragging = true; 
      const e = event.type === 'touchmove' ? event.touches[0] : event;
      this.floatBtn.x = e.clientX - this.dragOffset.x;
      this.floatBtn.y = e.clientY - this.dragOffset.y;
    },
    stopDrag(event) {
      const moveEvent = event.type === 'touchend' ? 'touchmove' : 'mousemove';
      const upEvent = event.type === 'touchend' ? 'touchend' : 'mouseup';
      document.removeEventListener(moveEvent, this.doDrag);
      document.removeEventListener(upEvent, this.stopDrag);
      setTimeout(() => { this.dragging = false; }, 100); 
    }
  },

  mounted() {
    this.floatBtn = { x: window.innerWidth - 80, y: window.innerHeight - 160 };
    const { course } = getStepsInformation();
    if (course) {
      this.course = course;
    }
  }
};
</script>

<style scoped>
.custom-large-popup >>> .vs-popup { width: 95vw !important; max-width: none !important; height: 95vh !important; display: flex; flex-direction: column; }
.custom-large-popup >>> .vs-popup--content { overflow: hidden !important; padding: 30px !important; display: flex; flex-direction: column; }
.popup-inner-margin { display: flex; flex-direction: column; height: 100%; }
.floating-button-container { position: fixed; z-index: 10000; cursor: grab; }
.floating-button-container:active { cursor: grabbing; }
.tables-container { display: flex; justify-content: space-between; gap: 20px; flex: 1; max-height: calc(95vh - 170px); overflow-y: auto; overflow-x: hidden; }

.table-wrapper { 
  flex: 1; 
  width: calc(50% - 10px); 
  max-width: calc(50% - 10px); 
  min-width: 0;
  display: flex; 
  flex-direction: column; 
}
.table-responsive { overflow-x: auto; width: 100%; }

.table-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.table-search-input { padding: 4px 8px; font-size: 12px; border: 1px solid #ccc; border-radius: 4px; width: 160px; outline: none; transition: border-color 0.2s ease; }
.table-search-input:focus { border-color: #ea1d2c; }

.custom-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.custom-table th, .custom-table td { border: 1px solid #ddd; padding: 6px 8px; text-align: left; white-space: nowrap; transition: background-color 0.2s; }
.custom-table th { background-color: #f2f2f2; position: sticky; top: 0; z-index: 2; }
.clickable-row { cursor: pointer; }
.clickable-row:hover td { filter: brightness(0.95); }

.legend-container { display: flex; align-items: center; gap: 8px; font-size: 13px; }
.legend-badge { padding: 2px 8px; border-radius: 4px; font-weight: bold; font-size: 12px; }
</style>